import clsx from 'clsx'
import type { ReactNode } from 'react'

import { ICON } from '@/src/general/enums/icons'

import { Avatar } from '../avatar'
import { ListboxItem } from '../listbox'
import { Icon } from '../media/Icon'

export type TSaintListItemProps = {
  iconUrl: string
  name: string
  isSelected?: boolean
  onPress: () => void
  testId?: string
}
export const SaintListItem = ({ name, iconUrl, isSelected, onPress, testId }: TSaintListItemProps): ReactNode => {
  return (
    <ListboxItem
      onPress={onPress}
      startContent={<Avatar className="self-center" src={iconUrl} />}
      className="flex items-center"
      endContent={
        <Icon
          testID={testId ? `${testId}-icon` : `${iconUrl}-icon`}
          name={isSelected ? ICON.CHECK_CIRCLE_BROKEN : ICON.CHEVRON_RIGHT}
          className={clsx({
            'color-success-text-contrast-low': isSelected,
            'color-default-icon-contrast-lower': !isSelected,
          })}
          size="sm"
        />
      }
    >
      {name}
    </ListboxItem>
  )
}
